import { Film, Video, Youtube } from 'lucide-solid'
import type { VideoProvider } from './detectVideoUrl'

export const PROVIDER_META: Record<VideoProvider, { label: string; icon: typeof Youtube }> = {
	youtube: { label: 'YouTube', icon: Youtube },
	vimeo: { label: 'Vimeo', icon: Film },
	dailymotion: { label: 'Dailymotion', icon: Video },
}
